import {createSlice} from '@reduxjs/toolkit';

const companiesSlice = createSlice({
    name: 'companies',
    initialState: [],
    reducers: {
        setCompanies: (_, action) => action.payload,
        addCompany: (state, action) => [...state, action.payload],
        updateCompanyById: (state, action) =>
            state.map(c => c.id === action.payload.id ? action.payload : c),
        removeCompanyById: (state, action) =>
            state.filter(c => c.id !== action.payload),
    },
    selectors: {
        selectCompanies: s => s,
    },
});

export const {setCompanies, addCompany, updateCompanyById, removeCompanyById} = companiesSlice.actions;
export const {selectCompanies} = companiesSlice.selectors;
export const {reducer} = companiesSlice;
